export default [
  {
    path: '/ai-agent',
    component: () => import('../../views/AIAgentLayout'),
    children: [
      {
        path: '',
        name: 'ai-agent',
        redirect: 'agents'
      },
      {
        path: 'agents',
        name: 'agentHub',
        component: () => import('../../components/Pages/AIAgent/AgentHub')
      },
      {
        path: 'agent/new',
        name: 'CreateAgent',
        component: () => import('../../components/Pages/AIAgent/AgentCrud'),
        meta: {
          title: 'Create Agent'
        }
      },
      {
        path: 'agent/:agentId/edit',
        name: 'EditAgent',
        component: () => import('../../components/Pages/AIAgent/AgentCrud'),
        meta: {
          title: 'Edit Agent'
        }
      },
      {
        path: 'agent/:agentId/sessions',
        name: 'agentSessions',
        component: () => import('../../components/Pages/AIAgent/AgentSessions'),
        meta: {
          title: 'Agent Sessions'
        }
      },
      {
        path: 'agent/:agentId/chat',
        name: 'agentChat',
        component: () => import('../../components/Pages/AIAgent/AgentChat')
      },
      {
        path: 'agent/:agentId/:projectId/chat',
        name: 'projectChat',
        component: () => import('../../components/Pages/AIAgent/AgentChat')
      },
      {
        path: 'agent/:agentId/chat/:sessionId',
        name: 'projectChatSession',
        component: () => import('../../components/Pages/AIAgent/AgentChat')
      },
      {
        path: 'agent/:agentId/:projectId/chat/:sessionId',
        name: 'agentChatSession',
        component: () => import('../../components/Pages/AIAgent/AgentChat')
      },
      {
        path: 'agent/:agentId/knowledge-base',
        name: 'agentKnowledgeBase',
        component: () => import('../../components/Pages/AIAgent/KnowledgeBaseManager'),
        meta: { title: 'Knowledge Base' }
      },
      {
        path: 'agent/:agentId/projects/:projectId/knowledge-base',
        name: 'knowledgeBaseManager',
        component: () => import('../../components/Pages/AIAgent/KnowledgeBaseManager'),
        meta: {
          title: 'Project Knowledge Base'
        }
      },
      {
        path: 'tools',
        name: 'ToolList',
        component: () => import('../../components/Pages/AIAgent/Tools/ToolList'),
        meta: { title: 'Tools' }
      },
      {
        path: 'tools/new',
        name: 'CreateTool',
        component: () => import('../../components/Pages/AIAgent/Tools/ToolCrud'),
        meta: { title: 'Create Tool' }
      },
      {
        path: 'tools/:toolId/edit',
        name: 'EditTool',
        component: () => import('../../components/Pages/AIAgent/Tools/ToolCrud'),
        meta: { title: 'Edit Tool' }
      },
      {
        path: 'api-keys',
        name: 'ApiKeys',
        component: () => import('../../components/Pages/AIAgent/ApiKeys'),
        meta: {
          title: 'API Keys Management'
        }
      },
      {
        path: 'agent/:agentId/projects',
        name: 'agentProjects',
        component: () => import('../../components/Pages/AIAgent/AgentProjects'),
        meta: {
          title: 'Agent Projects'
        }
      },
      {
        path: 'agent/:agentId/projects/:projectId',
        name: 'projectDetail',
        component: () => import('../../components/Pages/AIAgent/ProjectDetail'),
        meta: {
          title: 'Project Details'
        }
      },

      // ==================== Workflow Routes ====================

      // Workflow Hub - List all workflows for a project
      {
        path: 'agent/:agentId/projects/:projectId/workflows',
        name: 'workflowHub',
        component: () => import('../../components/Pages/AIAgent/WorkflowHub'),
        meta: {
          title: 'Workflows'
        }
      },

      /* // Create New Workflow
      {
        path: 'agent/:agentId/projects/:projectId/workflows/new',
        name: 'createWorkflow',
        component: () => import('../../components/Pages/AIAgent/WorkflowCrud'),
        meta: {
          title: 'Create Workflow'
        }
      },

      // Edit Workflow
      {
        path: 'agent/:agentId/projects/:projectId/workflows/:workflowId/edit',
        name: 'editWorkflow',
        component: () => import('../../components/Pages/AIAgent/WorkflowCrud'),
        meta: {
          title: 'Edit Workflow'
        }
      }, */

      // Workflow Execution History
      {
        path: 'agent/:agentId/projects/:projectId/workflows/:workflowId/executions',
        name: 'workflowExecutions',
        component: () => import('../../components/Pages/AIAgent/WorkflowExecutionList'),
        meta: {
          title: 'Workflow Executions'
        }
      },

      // Execution Detail
      {
        path: 'agent/:agentId/projects/:projectId/workflows/:workflowId/executions/:executionId',
        name: 'executionDetail',
        component: () => import('../../components/Pages/AIAgent/WorkflowExecutionDetail'),
        meta: {
          title: 'Execution Details'
        }
      },

      // ==================== NEW: Form Routes ====================

      // Form Builder/Manager
      {
        path: 'agent/:agentId/projects/:projectId/forms',
        name: 'formManager',
        component: () => import('../../components/Pages/AIAgent/FormManager'),
        meta: {
          title: 'Forms'
        }
      },

      // Create New Form
      {
        path: 'agent/:agentId/projects/:projectId/forms/new',
        name: 'createForm',
        component: () => import('../../components/Pages/AIAgent/FormBuilder'),
        meta: {
          title: 'Create Form'
        }
      },

      // Edit Form
      {
        path: 'agent/:agentId/projects/:projectId/forms/:formId/edit',
        name: 'editForm',
        component: () => import('../../components/Pages/AIAgent/FormBuilder'),
        meta: {
          title: 'Edit Form'
        }
      },

      // Form Submissions
      {
        path: 'agent/:agentId/projects/:projectId/forms/:formId/submissions',
        name: 'formSubmissions',
        component: () => import('../../components/Pages/AIAgent/FormSubmissions'),
        meta: {
          title: 'Form Submissions'
        }
      },

      // ==================== NEW: Integration Routes ====================

      // Integration Manager
      {
        path: 'agent/:agentId/projects/:projectId/integrations',
        name: 'integrationManager',
        component: () => import('../../components/Pages/AIAgent/IntegrationManager'),
        meta: {
          title: 'Integrations'
        }
      },

      // Create New Integration
      {
        path: 'agent/:agentId/projects/:projectId/integrations/new',
        name: 'createIntegration',
        component: () => import('../../components/Pages/AIAgent/IntegrationCrud'),
        meta: {
          title: 'Create Integration'
        }
      },

      // Edit Integration
      {
        path: 'agent/:agentId/projects/:projectId/integrations/:integrationId/edit',
        name: 'editIntegration',
        component: () => import('../../components/Pages/AIAgent/IntegrationCrud'),
        meta: {
          title: 'Edit Integration'
        }
      },

      // Integration Logs
      {
        path: 'agent/:agentId/projects/:projectId/integrations/:integrationId/logs',
        name: 'integrationLogs',
        component: () => import('../../components/Pages/AIAgent/IntegrationLogs'),
        meta: {
          title: 'Integration Logs'
        }
      },

      // ==================== NEW: Dashboard & Reports Routes ====================

      // Project Dashboard (Workflow Analytics)
      {
        path: 'agent/:agentId/projects/:projectId/dashboard',
        name: 'projectDashboard',
        component: () => import('../../components/Pages/AIAgent/ProjectDashboard'),
        meta: {
          title: 'Project Dashboard'
        }
      },

      // Integration Health Report
      {
        path: 'agent/:agentId/projects/:projectId/integrations/health',
        name: 'integrationHealth',
        component: () => import('../../components/Pages/AIAgent/IntegrationHealth'),
        meta: {
          title: 'Integration Health'
        }
      },

      {
        path: 'agent/:agentId/projects/:projectId/workflows/:workflowId/builder',
        name: 'workflowBuilder',
        component: () => import('../../components/Pages/AIAgent/WorkflowBuilder'),
        meta: {
          title: 'Workflow Builder'
        }
      }
    ]
  }
]
